import KycLevelInfoBox from './KycLevelInfoBox';

export default KycLevelInfoBox;
